var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEventNodata({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 78 86",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8a8 8 0 0 0-8 8v64a8 8 0 0 0 8 8h28c-1.64-1-3.2-2.24-4.56-3.6C30.12 75.08 29 73.6 28 72H8V8h28v20h20v4.72c2.84.64 5.56 1.72 8 3.28V24L40 0m25.24 67.6c5.32-8.44 2.76-19.6-5.6-24.88C51.2 37.4 40 40 34.76 48.32 29.4 56.76 32 67.88 40.36 73.2c5.84 3.72 13.28 3.72 19.16.08L72 85.56 77.56 80 65.24 67.6M50 68c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEventNodata);
export default __webpack_public_path__ + "static/media/icon_event_nodata.e54d6b249f615c1872791fb30f8296d9.svg";
export { ForwardRef as ReactComponent };